<div class="d-flex justify-content-center align-items-center w-100 h-100">
  <div class="d-flex flex-column justify-content-center">
    <p-progressSpinner></p-progressSpinner>
    <div class="connecting-to-instagram-spinner-desc">{{'VENUE.CONNECTING_TO_INSTAGRAM_PROGRESS_SPINNER' | translate}}</div>
  </div>
</div>
